export default __webpack_public_path__ + "static/media/shopify_connect-1.d56fdedd.svg";